// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Eye = function Eye(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8 3.522C4.266 3.522 1.156 5.919.332 8c.824 2.081 3.934 4.478 7.668 4.478s6.844-2.4 7.668-4.478C14.844 5.919 11.734 3.522 8 3.522zm0 8.323A3.846 3.846 0 1111.846 8 3.846 3.846 0 018 11.846z"
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "8",
      cy: "8",
      r: "2.736"
    }))
  );
};

export default Eye;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Eye.js
// module id = 1006
// module chunks = 0